import { useApiClient } from './util/useApiClient.util';

interface Return {
  logout: () => Promise<void>;
}

export const useLogout = (): Return => {
  const { logoutApi } = useApiClient();
  return {
    logout: async () => {
      const response = await logoutApi.logout();

      window.location.href = response.headers.location;
    },
  };
};
